/* eslint-disable */
import PropTypes from 'prop-types';
import I18nEntityPropTypes from '../../Services/I18n/I18n.service.props';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';

const OrderTimePropTypes = {
  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The date in string format (2018-08-21T16:24:39+10:00)
   */
  date: PropTypes.string.isRequired,

  /**
   * The current `locale
   */
  locale: I18nEntityPropTypes.locale.isRequired,

  /**
   * The toggle to show the date or not
   */
  showDate: PropTypes.bool,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,
};

export default OrderTimePropTypes;
